import { Input, Modal, ModalBody } from "reactstrap";
import styles from "./index.module.scss";
import { format } from "date-fns";
import DeleteConfirmation from "../DeleteConfirmation";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_SEARCH_CSO_LOG } from "../../../queries";
import { DELETE_SEARCH_LOG } from "../../../mutations";
import animetionLogo from "../../../../../../assets/utils/images/animetion_logo.gif";

const ListModal = (props) => {
  const { open, setOpen, onSearchLogClick } = props;
  const [deleting, setDeleting] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [targetDeleteId, setTargetDeleteId] = useState(null);

  const toggleDeleteConfirmation = () =>
    setDeleteConfirmationOpen((prev) => !prev);

  const { data: savedSearchData, refetch } = useQuery(GET_ALL_SEARCH_CSO_LOG);

  const [deleteSearchCso] = useMutation(DELETE_SEARCH_LOG);

  const data = savedSearchData?.allSearchCsoLog?.edges?.map(
    (edge) => edge?.node
  );

  const handleDeleteSearchCondition = async () => {
    try {
      setDeleting(true);
      toggleDeleteConfirmation();
      await deleteSearchCso({
        variables: {
          searchCsoLogId: targetDeleteId,
        },
      });
      refetch().then(() => {
        setDeleting(false);
      });
    } catch (err) {
      console.log(err);
    } finally {
      setDeleteConfirmationOpen(false);
    }
  };

  useEffect(() => {
    refetch();
  }, [open, refetch]);

  return (
    <>
      <DeleteConfirmation
        open={deleteConfirmationOpen}
        setOpen={toggleDeleteConfirmation}
        handleConfirmDelete={handleDeleteSearchCondition}
      />
      <Modal
        isOpen={open}
        toggle={setOpen}
        backdrop
        size="sm"
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["supporter-registration-modal"]}
        style={{
          width: "440px",
        }}
      >
        <ModalBody>
          <div
            style={{
              fontSize: "20px",
              marginBottom: "100px",
              textAlign: "center",
              marginTop: "72px",
            }}
          >
            条件変更
          </div>
          <div
            style={{
              marginBottom: "100px",
            }}
          >
            {deleting && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px 0",
                }}
              >
                <img
                  style={{ width: "80px", margin: "auto" }}
                  src={animetionLogo}
                ></img>
              </div>
            )}
            {!deleting &&
              data?.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      marginBottom: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "8px",
                        marginBottom: "2px",
                      }}
                    >
                      {format(new Date(item?.createdAt), "yyyy年MM月dd日")}
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 40px",
                        gap: "8px",
                      }}
                    >
                      <button
                        style={{
                          border: "none",
                          borderRadius: "8px",
                          color: "white",
                          backgroundColor: "#4A4A4A",
                          padding: "8px 16px",
                        }}
                        onClick={() => {
                          onSearchLogClick(item);
                        }}
                      >
                        {item.title}
                      </button>
                      <button
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#FFBCBA",
                          border: "1px solid #CD433E",
                          color: "#CD433E",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          setTargetDeleteId(item.id);
                          setDeleteConfirmationOpen(true);
                        }}
                      >
                        x
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ListModal;
